/**
 * Price zone system — determines which brand's pricing applies.
 * `SH` = Schülerhilfe (de/at/ch), `ERNA` = Erste Nachhilfe (ien).
 */
export enum PriceZoneSystem {
  SH = 'SH',
  ERNA = 'ERNA',
}
